import React, { useEffect } from "react";
import { ItemRender } from "./ItemRender/ItemRender";
import { Button, Col, Divider, Flex, Form, Row, Spin } from "antd";
import Title from "antd/es/typography/Title";

const layout = (isFilter) => ({
  ...(!isFilter && {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  }),
  layout: isFilter ? "inline" : "vertical",
});

export const CustomForm = ({
  name = "form-1",
  camposFormulario = null,
  initialValues = null,
  isFilter = false,
  queryFilter = null,
  querySubmit = () => { },
  create = true,
  setOpenModal = () => { },
  setRefetch = null,
  tituloForm = null,
  modificaSubmit = null,
}) => {
  const [form] = Form.useForm();
  const queryData = querySubmit();

  const randomId = Math.random().toString(36).substring(7);

  const onFinish = (data) => {
    if (isFilter) {
      queryFilter(data);
    } else {
      if (modificaSubmit) {
        data = modificaSubmit(data);
      }
      queryData.mutateAsync(data);
    }
  };

  useEffect(() => {
    if (queryData?.isSuccess) {
      form.resetFields();
      setOpenModal(false);
      if (setRefetch) setRefetch(queryData.data);
    }
  }, [queryData?.isSuccess]);
  return (
    <Flex justify="center" align={isFilter ? "start" : "center"} vertical>
      {create && !isFilter && tituloForm && (
        <>
          <Title style={{ textAlign: "center" }}>
            {tituloForm ?? "Configuración de " + camposFormulario.title}
          </Title>
          <Divider variant="solid" style={{ borderColor: "#000" }} />
        </>
      )}
      <Form
        {...layout(isFilter)}
        name={name + randomId}
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{
          ...(!isFilter && {
            maxWidth: 600,
          }),
          width: "100%",
          // minWidth: 300,
          padding: "30px",
        }}
      >
        {
          isFilter ? <>
            {camposFormulario &&
              camposFormulario.campos.map((props, index) => (
                <div
                  key={index}
                  style={{ marginBottom: "10px" }}>
                  <ItemRender key={index} keyItem={index} props={props} />
                </div>
              ))}
            <div style={{ textAlign: "center" }}>
              <Button style={{ minWidth: 100 }} type="primary" htmlType="submit">
                {isFilter ? "Filtrar" : "Guardar"}
              </Button>
            </div>
          </> : (<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            {camposFormulario &&
              camposFormulario.campos.map((props, index) => (
                <Col
                  key={index}
                  className="gutter-row" span={props.span ?? 24}
                  style={{
                    display: props.invisible ? 'none' : "block"
                  }}>
                  <ItemRender key={index} props={props} />
                </Col>
              ))}
            <div style={{ textAlign: "center" }}>
              <Col className="gutter-row" span={24}>
                <Button style={{ minWidth: 100 }} type="primary" htmlType="submit">
                  {isFilter ? "Filtrar" : "Guardar"}
                </Button>
              </Col>
            </div>
          </Row>)
        }
      </Form>
      {queryData?.isLoading && (
        <Spin fullscreen={true} tip="Cargando..."></Spin>
      )}
    </Flex>
  );
};
